<template>
  <svg :class="[preview ? 'hexagon_svg_gradient2' : 'hexagon_svg',gradient ? 'hexagon_svg_gradient' : 'hexagon_svg', outline ? 'hexagon_svg_outline' : 'hexagon_svg', blue ? 'hexagon_svg_gradient_blue' : 'hexagon_svg']" version="1.1" xmlns="http://www.w3.org/2000/svg"  x="0" y="0" width="30" height="30" viewbox="0 0 300 250.980762113533157" style="filter: drop-shadow(rgba(0, 0, 0, 0.75) 0px 0px 3px);">
    <path class="hexagon_path"  d="M0 12.990381056766578L7.5 0L22.5 0L30 12.990381056766578L22.5 25.980762113533157L7.5 25.980762113533157Z"></path>
    <linearGradient id="blue-to-green" x2="1" y2="1">
      <stop offset="0%" stop-color="#51b3e3" />
      <stop offset="100%" stop-color="#83c06f" />
    </linearGradient>
    <linearGradient id="blue-to-blue" x2="1" y2="1">
      <stop offset="0%" stop-color="#3A55A2" />
      <stop offset="100%" stop-color="#51b3e3" />
    </linearGradient>
  </svg>        
</template>
<script>
export default {
  name: "hexagon",
  props: {
    gradient: Boolean,
    outline: Boolean,
    blue: Boolean,
    preview: Boolean
  }
};
</script>


<style>
.hexagon_svg_gradient {
  position: absolute;
  background: transparent;
  top: 15px;
  left: 18px;
  width: 50px;
  height: 50px;
  transition: 0.4s;
  fill: url("#blue-to-blue") !important;
}

.hexagon_svg_gradient2 {
  position: absolute;
  background: transparent;
  top: 15px !important;
  left: 0px;
  width: 50px;
  height: 50px;
  transition: 0.4s;
  fill: url("#blue-to-blue") !important;
}

.hexagon_svg_gradient_blue {
  position: absolute;
  background: transparent;
  top: 15px;
  left: 18px;
  width: 50px;
  height: 50px;
  transition: 0.4s;
  fill: url("#blue-to-blue") !important;
}
.hexagon_svg_outline {
  position: absolute;
  background: transparent;
  top: 15px;
  left: 18px;
  width: 52px !important;
  height: 52px !important;
  transition: 0.4s;
  fill: none !important;
  stroke: url("#blue-to-green");
  stroke-width: 1px;
  stroke-linejoin: round;
}
.hexagon_svg {
  position: absolute;
  background: transparent;
  top: 1px;
  left: 18px;
  width: 50px;
  height: 50px;
  transition: 0.4s;
  fill: #424242;
}

.hexagon_path {
  transform: scale(1.68) !important;
  /* transform: scale(1.52)!important; */
}

.hexagon_icon {
  z-index: 1;
  position: absolute;
  top: 11px;
  left: 28px;
}
.hexagon_icon_ittention {
  /* fill: white;
  transform: scale(.05);
  z-index: 1;
  position: absolute;
  top: -274px;
  left: -267px; */
  fill: white;
  /* -webkit-transform: scale(.05); */
  /* transform: scale(.05); */
  width: 33px;
  z-index: 1;
  position: absolute;
  top: -2px;
  left: 27px;
}
</style>
